import { atom, selectorFamily } from 'recoil'

import type {
  RecipientGroupsItem,
  RecipientsGroupsState,
} from 'Pages/RecipientsList/model'

export const recipientsGroupsState = atom<RecipientsGroupsState>({
  key: 'recipientsList_recipientsGroupsState',
  default: {
    status: 'initial',
    items: [],
  },
})

export const recipientGroupsInListState = selectorFamily<
  RecipientGroupsItem,
  number
>({
  key: 'recipientsList_recipientGroupsInListState',
  get:
    (idRecipient: number) =>
    ({ get }) => {
      const { items } = get(recipientsGroupsState)

      const item = items.find((o) => o.idRecipient === idRecipient)

      return (
        item ?? {
          idRecipient,
          moreItems: false,
          items: [],
        }
      )
    },
})
